import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title,
} from 'chart.js';

// Register necessary chart.js components
ChartJS.register(ArcElement, Tooltip, Legend, Title);

const DoughnutChart = (props) => {
    const { orderData } = props;

    const [cashOrderData, setCashOrderData] = useState(0);
    const [digitalOrderData, setDigitalOrderData] = useState(0);

    useEffect(() => {
        if (Array.isArray(orderData)) {
            // Filter orders by payment type
            const cashOrders = orderData.filter(item => item.paymentGatewayName === "COD");
            const digitalOrders = orderData.filter(item => item.paymentGatewayName === "Razorpay");

            // Calculate total order amounts for each payment type
            const totalCash = cashOrders.reduce((sum, item) => sum + (parseFloat(item.orderAmount) || 0), 0);
            const totalDigital = digitalOrders.reduce((sum, item) => sum + (parseFloat(item.orderAmount) || 0), 0);

            // Update state
            setCashOrderData(totalCash.toFixed(2));
            setDigitalOrderData(totalDigital.toFixed(2)); 
        }
    }, [orderData]);

    const data = {
        labels: ['Digital Payments', 'Cash Payments'],
        datasets: [
            {
                label: 'Payment Distribution',
                data: [parseFloat(digitalOrderData), parseFloat(cashOrderData)],
                backgroundColor: ['rgba(0, 65, 136, 0.8)', 'rgba(54, 162, 235, 0.8)'],
                borderColor: ['rgba(0, 65, 136, 1)', 'rgba(54, 162, 235, 1)'],
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: false,
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        return `${tooltipItem.label}: ₹${tooltipItem.raw.toLocaleString()}`;
                    }
                }
            },
        },
    };


    return (
        <div>
            <Doughnut data={data} options={options} />
            <div className="all_dots">
                <div className="before-bg ">
                    <span>Cash Payments {`(₹${cashOrderData})`}</span>
                </div>
                <div className="before-bg digital_color">
                    <span>Digital Payments {`(₹${digitalOrderData})`}</span>
                </div>
            </div>
        </div>
    );
};

export default DoughnutChart;
